import React from 'react';
import { RotateCcw } from 'lucide-react';

const ReplayButton = ({ onClick, className = '', fixed = false }) => {
  const baseClasses = "group flex items-center gap-2 px-4 py-2 bg-white border-2 border-slate-300 rounded-full shadow-lg hover:shadow-xl hover:border-slate-400 transition-all duration-200";
  const positionClasses = fixed ? "fixed bottom-8 right-8 z-20" : "";

  return (
    <button
      onClick={onClick}
      className={`${baseClasses} ${positionClasses} ${className}`}
      aria-label="Replay animation"
    >
      <RotateCcw className="w-4 h-4 text-slate-600 group-hover:text-slate-900 group-hover:rotate-[-360deg] transition-all duration-500" />
      <span className="text-sm font-medium text-slate-600 group-hover:text-slate-900">
        Replay
      </span>
    </button>
  );
};

export default ReplayButton;